import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { majorScale } from 'evergreen-ui'

export default class CatalogIcon extends PureComponent {
  static propTypes = {
    fill: PropTypes.string,
    size: PropTypes.number
  }

  static defaultProps = {
    fill: 'currentColor',
    size: majorScale(3)
  }

  render() {
    const { fill, size } = this.props

    return (
      <svg width={size} height={size} viewBox="0 0 24 24">
        <path
          d="M2 2v6h6V2H2zM1 0h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm1 16v6h6v-6H2zm-1-2h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1zm15 2v6h6v-6h-6zm-1-2h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1zm1-12v6h6V2h-6zm-1-2h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z"
          fill={fill}
        />
      </svg>
    )
  }
}
